const Config = {
  IS_DEVELOPMENT_URL: process.env.IS_DEVELOPMENT_URL,
  NETLIFY_CONTACT_FORM_NAME: process.env.NETLIFY_CONTACT_FORM_NAME,
  RECAPTCHA_KEY: process.env.RECAPTCHA_KEY || '',
  SWIFTYPE_API_ENDPOINT: process.env.SWIFTYPE_API_ENDPOINT || '',
  SWIFTYPE_ENGINE_KEY: process.env.SWIFTYPE_ENGINE_KEY || '',
};

export default Config;
